import Todo from '../models/Todo';
import {localAxiosRequest} from "@/utils/axios";
const CONSIGNEES_BASE_URL = '/consignees';

/**
 * 新增收货地址
 */
const addConsignee = function (param: Object): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'POST',
        url: `${CONSIGNEES_BASE_URL}/add`,
        data: param
    },true);
};

/**
 * 编辑收货地址
 */
const editConsignee = function (param: Object): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'POST',
        url: `${CONSIGNEES_BASE_URL}/edit`,
        data: param
    },true);
};

/**
 * 删除收货地址
 */
const deleteConsignee = function (id: number): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'DELETE',
        url: `${CONSIGNEES_BASE_URL}/${id}/delete`,
    });
};

/**
 * 根据id获取单个收货地址
 */
const getConsigneeById = function (id: number): Promise<Todo[]> {
    return localAxiosRequest({
        method: 'GET',
        url: `${CONSIGNEES_BASE_URL}/${id}/consignee`,
    });
};

export { addConsignee, editConsignee, deleteConsignee, getConsigneeById };
